<!-- ...existing code... -->
<div class="page-content fade-in-up">
    <div class="row">

        <div class="col-lg-12 col-md-12">

            <div class="card">
                <div class="card-header">
                    <h5 class="mb-0">Field Code-Value Manage</h5>
                </div>

                <div class="card-body">
                    <!-- <ul class="nav nav-tabs tabs-line">
                        <li class="nav-item">
                            <a class="nav-link active" href="#tab-1" data-bs-toggle="tab" (click)="goToList()"><i
                                    class="ti-bar-chart"></i>
                                All Fields Code-Value List
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#tab-2" data-bs-toggle="tab" (click)="gotoCreate()"><i
                                    class="fa fa-plus-circle"></i>
                                Create Field Code-Value
                            </a>
                        </li>
                    </ul> -->
                    
                    <ul class="nav nav-tabs tabs-line" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" id="tab1-tab" href="#tab-1" data-bs-toggle="tab" role="tab"
                               aria-controls="tab-1" aria-selected="true" (click)="goToList()">
                                <i class="ti-bar-chart"></i>
                                All Fields Code-Value List
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="tab2-tab" href="#tab-2" data-bs-toggle="tab" role="tab"
                               aria-controls="tab-2" aria-selected="false" (click)="gotToCreate()">
                                <i class="fa fa-plus-circle"></i>
                                Create Field Code-Value
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content" *ngIf="list_flag">
                        <div id="tab-1">
                            <br>
                            <ng-select [items]="allFields" bindLabel="field_business_name" (change)="changeField()"
                                bindValue="field_code" [multiple]="false"
                                placeholder="{{mainService.allLableShowObj[mainService.language_cd+'Code_Value14']}}"
                                [(ngModel)]="selectField" [selectableGroup]="true" [selectableGroupAsModel]="false"
                                [closeOnSelect]="true" name="field_name">
                            </ng-select>
                            <hr>
                            <br>
                            <mat-form-field style="margin-left: 2%">
                                <input matInput (keyup)="applyFilter($event.target)" placeholder="Search">

                            </mat-form-field>

                            <div class=" example-container">
                                <table mat-table [dataSource]="datasource" matSort>
                                    <ng-container matColumnDef="id">
                                        <th mat-header-cell *matHeaderCellDef class="left" mat-sort-header>
                                            ID

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element; let i = index; "
                                            class="right">
                                            {{ element.id }}</td>
                                    </ng-container>


                                    <ng-container matColumnDef="code">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                            Code

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.code }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="value">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                            Value

                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                            {{ element.value }} </td>
                                    </ng-container>


                                    <ng-container matColumnDef="action">
                                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                                            Action
                                        </th>
                                        <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                            <button type="button" class="btn btn-primary"
                                                (click)="open_update(element)">
                                                Update
                                            </button>
                                            <button type="button" class="btn btn-danger"
                                                (click)="delete(element)">Delete</button>

                                        </td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                    </tr>
                                </table>
                                <mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                            </div>


                        </div>
                        <div class="tab-pane fade" id="tab-2">
                            <br>

                            <ng-select [items]="allFields" bindLabel="field_business_name" bindValue="field_code"
                                [multiple]="false" placeholder="Select Fields" [(ngModel)]="selectField"
                                [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                                name="field_name"><!-- Select Fields -->
                            </ng-select>

                            <hr>
                            <br>
                            <div class="row">
                                <div class="col-4 text-end">
                                    Field Code:
                                </div>
                                <div class="col-4">

                                    <input type="text" class="form-control" [(ngModel)]="obj['code']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-4 text-end">
                                    Field Value:
                                </div>
                                <div class="col-4">
                                    <input type="text" class="form-control" [(ngModel)]="obj['value']">
                                </div>
                            </div>
                            <br>
                            <div class="row">
                                <div class="col-12 text-center">
                                    <button type="button" class="btn btn-primary" (click)="save()">
                                        Submit
                                    </button>

                                </div>
                            </div>
                        </div>

                        <div class="tab-pane fade" id="tab-3">

                        </div>

                    </div>
                    <div class="tab-content" *ngIf="update_flag || create_flag">
                        <br>
                        <ng-select [items]="allFields" bindLabel="field_business_name" bindValue="field_code"
                            [multiple]="false" [(ngModel)]="selectField" [selectableGroup]="true"
                            [selectableGroupAsModel]="false" [closeOnSelect]="true" name="field_name">
                        </ng-select>

                        <hr>
                        <br>
                        <div class="row">
                            <div class="col-4 text-end">
                                Field Code:
                            </div>
                            <div class="col-4">

                                <input type="text" class="form-control" [(ngModel)]="obj['code']" [disabled]="update_flag">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-4 text-end">
                                Field Value:
                            </div>
                            <div class="col-4">
                                <input type="text" class="form-control" [(ngModel)]="obj['value']">
                            </div>
                        </div>
                        <br>
                        <div class="row">
                            <div class="col-12 text-center">
                              <button type="button" class="btn btn-danger" (click)="goToList()">Back</button>
                                <button type="button" class="btn btn-primary" (click)="update()" *ngIf="update_flag">
                                    Update
                                </button>
                                <button type="button" class="btn btn-primary" (click)="save()" *ngIf="create_flag">
                                    Save
                                </button>

                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</div>
<ngx-spinner>Loading....</ngx-spinner>
 